import { OndemandBannerTray } from '../../../domain/ondemand-banner';
import {
  CreateOndemandBannerPageItemRequestApiModel,
  UpdateOndemandBannerPageItemRequestApiModel,
  OndemandBannerPageItemApiModel,
} from '@cxb/editor-stb-api';
import { mapperPipe, remainderMapper } from 'osn-shared';
import { scheduledDateMapperDomainToApi, targetingMapperDomainToApi } from '../../mapping/create-tray-domain-to-api';
import { commonMapper, scheduledDateMapperApiToDomain, targetingMapperApiToDomain } from '../../mapping/create-tray-api-to-domain';
import { OndemandBannerTrayFormViewModel } from './ondemand-banner-tray-form.view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import { scheduledDateMapperDomainToViewModel, targetingMapper } from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import { scheduledDateMapperViewModelToDomain } from '../create-tray-screen/mapping/create-tray-vm-to-domain';

export const mapOndemandBannerTrayDomainModelToApiModel = (
  item: OndemandBannerTray,
  pageVersionId?: string,
  tenantId?: string
): CreateOndemandBannerPageItemRequestApiModel & UpdateOndemandBannerPageItemRequestApiModel => {
  const { nameLocalized, descriptionLocalized } = item;

  const commonProperties = mapperPipe(item, targetingMapperDomainToApi, scheduledDateMapperDomainToApi);

  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    descriptionLocalized,
    nameLocalized,
    tenantId,
    platformIds: item.platformIds || [],
  }));
};

export const mapOndemandBannerTrayApiModelToDomainModel = (pageItem: OndemandBannerPageItemApiModel): OndemandBannerTray => {
  const { nameLocalized, descriptionLocalized } = pageItem;

  return remainderMapper(mapperPipe(pageItem, commonMapper, targetingMapperApiToDomain, scheduledDateMapperApiToDomain), () => ({
    type: 'OndemandBannerTray',
    descriptionLocalized,
    nameLocalized,
  }));
};

export const mapOndemandBannerTrayDomainModelToViewModel = (pageItem: OndemandBannerTray): OndemandBannerTrayFormViewModel => {
  const { nameLocalized, descriptionLocalized } = pageItem;

  const commonProperties = mapperPipe(pageItem, commonMapper, targetingMapper, scheduledDateMapperDomainToViewModel);

  return remainderMapper(commonProperties, () => ({
    type: TrayFormViewModelType.OndemandBannerTray,
    descriptionLocalized,
    nameLocalized,
  }));
};

export const mapOndemandBannerTrayViewModelToDomainModel = (vm: OndemandBannerTrayFormViewModel): OndemandBannerTray => {
  const { nameLocalized, descriptionLocalized } = vm;

  const commonProperties = mapperPipe(vm, commonMapper, targetingMapper, scheduledDateMapperViewModelToDomain);

  return remainderMapper(commonProperties, () => ({
    type: 'OndemandBannerTray',
    descriptionLocalized,
    nameLocalized,
  }));
};
